/**
 * Extends the vue-summernote component by injecting
 * a custom mixin that enhances image handling.
 *
 * This file does not create a new component.
 * It modifies the existing vue-summernote component
 * by adding `imageWrapperMixin` to its lifecycle hooks.
 *
 * Usage:
 *   Call `extendSummernoteComponent()` after VueSummernote
 *   has been installed to ensure the component exists.
 *
 * Important:
 * - This is a side-effect operation.
 * - Keep the logic isolated to this file for maintainability.
 */

import Vue from 'vue';
import { imageWrapperMixin } from './imageWrapper.mixin';

/**
 * Patches the vue-summernote component with a mixin.
 * The mixin runs after the editor is mounted and attaches
 * the ImageWrapperManager to the Summernote instance.
 */
export function extendSummernoteComponent() {
    const SummernoteComponent = Vue.component('vue-summernote');

    // Exit early if the component is not yet registered
    if (!SummernoteComponent) return;

    // Ensure the component has a mixins array
    SummernoteComponent.options.mixins =
        SummernoteComponent.options.mixins || [];

    // Inject the image wrapper mixin
    SummernoteComponent.options.mixins.push(imageWrapperMixin);
}
